/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const productOverviewNodes = Array.from(document.querySelectorAll('.product-overview'));
if (productOverviewNodes.length) {
    import(/* webpackChunkName: "ProductOverview" */ './components/ProductOverview').then(({ default: ProductOverview }) => {
        productOverviewNodes.forEach((node) => render(<ProductOverview {...parseDataToProps(node.dataset)} />, node));
    });
}
